import {getConfig} from './config'
import {fetchAuthSession} from 'aws-amplify/auth'
import {AppDispatch} from '../store/store'
import {residentPortalApi} from './residentPortalApi'
import {getLogger} from './logging'

interface ResidentPortalNotification {
  event: string
}

const logger = getLogger('residentPortalWS')

function processMessage(message: MessageEvent, dispatch: AppDispatch) {
  try {
    const notification = JSON.parse(message.data) as ResidentPortalNotification
    const {event} = notification
    switch (event) {
      case 'ADD_PAYMENT_ACCOUNT':
        // invalidate payment accounts cache, trigger refresh
        logger.logInfo('Received add payment account notification event', {
          event
        })
        dispatch(residentPortalApi.util.invalidateTags(['PaymentAccount']))
        break
      case 'ONE_TIME_PAYMENT':
        // invalidate folio cache (containing payments), trigger refresh
        logger.logInfo('Received one time payment notification event', {
          event
        })
        dispatch(residentPortalApi.util.invalidateTags(['Folio']))
        break
      default:
        logger.logWarn(
          'Unable to process invalid resident portal notification event',
          {
            event
          }
        )
    }
  } catch (e) {
    logger.logError('Unable to process Resident Portal WS message', {
      error: e,
      message
    })
  }
}

export async function openWebSocket(dispatch: AppDispatch): Promise<WebSocket> {
  // get access token
  const session = await fetchAuthSession()
  const token = session.tokens.idToken.toString()

  // build websocket connection URL
  const {residentPortalWSUrl} = getConfig()
  const websocketUrl = `${residentPortalWSUrl}?access_token=${token}`

  // initialize websocket
  const ws = new WebSocket(websocketUrl)
  ws.addEventListener('open', () =>
    logger.logInfo(`Web socket opened: ${websocketUrl}`)
  )
  ws.addEventListener('close', () =>
    logger.logInfo(`Web socket closed: ${websocketUrl}`)
  )
  ws.addEventListener('message', (message: MessageEvent) =>
    processMessage(message, dispatch)
  )
  return ws
}
